import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
    selector: 'lib-gesuch-page-layout',
    imports: [],
    templateUrl: './gesuch-page-layout.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GesuchPageLayoutComponent {}
